export enum SaleChannelEnum {
  DESKTOP_APP = 1,
  MOBILE_APP = 2,
  WEB_APP = 3,
  CUSTOMER_APP = 4,
}
